module.exports = __webpack_public_path__ + "assets/img/login.7068e946.jpg";